<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset, errors}" ref="observer" slim>
    <b-tab :title-link-class="hasErrors(errors) ? 'has-error' : ''">
      <template v-slot:title>
        {{ $t('Contract Settings') }}
        <span v-if="hasErrors(errors)" style="width: 20px;height: 20px" id="premium-exclamation-icon">
          <font-awesome-icon class="text-danger hover-cursor" icon="exclamation-circle"/>
        </span>
      </template>

      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <h5 class="d-inline-block mb-0">
                    {{ $t('Recipients') }}
                  </h5>
                  <b-button class="float-right p-0" variant="link"
                            @click="onAddNewRecipientClick">
                    <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
                    {{ $t('Add New Recipient') }}
                  </b-button>
                </div>
                <div class="card-body pb-0">
                  <div class="row" v-if="model.contract_default_recipients && model.contract_default_recipients.length > 0">
                    <div class="col-md-12">

                      <div class="row">
                        <div class="col-md-4 font-weight-bold">{{ $t('Email') }}</div>
                        <div class="col-md-3 font-weight-bold">{{ $t('Name') }}</div>
                        <div class="col-md-3 font-weight-bold">{{ $t('Routing Order') }}</div>
                        <div class="col-md-2 font-weight-bold">{{ $t('Actions') }}</div>
                        <div class="col-md-12">
                          <hr class="mt-2 mb-2">
                        </div>
                      </div>

                      <div v-for="(recipient, idx) in model.contract_default_recipients" :key="`branch-setting-contract-recipient-${idx}`" class="row">
                        <div class="col-md-4">
                          <input-widget :model="recipient" attribute="email" :label="false" :placeholder="true"
                                        :disabled="recipient.disabled"/>
                        </div>
                        <div class="col-md-3">
                          <input-widget :model="recipient" attribute="display_name" :label="false" :placeholder="true"
                                        :disabled="recipient.disabled"/>
                        </div>
                        <div class="col-md-3">
                          <input-widget :model="recipient" attribute="routing_order" :label="false" :placeholder="true"
                                        type="number"/>
                        </div>
                        <div class="col-md-2">
                          <b-button class="text-danger text-white" variant="danger" @click="onRecipientRemoveClick(idx)"
                                    :disabled="recipient.disabled">
                            <font-awesome-icon class="text-white" icon="times" style="font-size: .9em"></font-awesome-icon>
                          </b-button>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="row" v-else>
                    <div class="col-md-12">
                      <no-data-available height="5"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </b-tab>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from "vuex";
  import InputWidget from "@/core/components/input-widget/InputWidget.vue";
  import RecipientModel from "@/modules/contracts/Recipient.model";
  import NoDataAvailable from "@/core/components/common/NoDataAvailable.vue";

  const {mapState} = createNamespacedHelpers('setup/branch');

  export default {
    name: "ContractSettings",
    components: {NoDataAvailable, InputWidget},
    data() {
      return {};
    },
    props: {
      model: {
        type: Object,
        required: true
      },
      show: {
        type: Boolean,
        required: false
      }
    },
    computed: {
      ...mapState(['selectedBranch']),
    },
    methods: {
      hasErrors(errors) {
        for (let i in errors) {
          if (errors[i].length > 0) {
            return true;
          }
        }
        return false;
      },
      onAddNewRecipientClick() {
        this.model.contract_default_recipients.push(new RecipientModel())
      },
      onRecipientRemoveClick(idx) {
        this.model.contract_default_recipients.splice(idx, 1)
      },
    }
  }
</script>

<style lang="scss" scoped>
  .footnote-textarea {
    /deep/ textarea {
      resize: none;
      height: 120px;
    }
  }
</style>
